<template>
    <div id="secondBack">
        <section>
            <h3>
                <label>温馨提示：</label>
            </h3>
            <ul>
                <li>开通秒返即可享受秒返服务</li>
                <li>每一笔订单支付成功后，佣金会立即返到绑定微信号的零钱</li>
                <li>小于0.3元的佣金，受微信控制不能秒返</li>
                <li>没有秒返的佣金于次月1号生成订单核算，再进行对账</li>
            </ul>            
        </section>
        <section>
            <h3>
                <label class="fl">开通秒返：</label> 
                <mt-switch v-model="secondBackState" @change="updateSecondBackStateHandler"></mt-switch>
            </h3>
            <!-- <div class="logo">
                <img src="@/assets/logo.jpg" alt="微信头像"><br/>
                <span>子墨</span>
            </div> -->
        </section>
    </div>
</template>
<script>
import { wxRequest} from '@/api/agent.js'
export default {
    data(){
        return {
            secondBackState: ''
        }
    },
    methods: {
        updateSecondBackStateHandler(){
            wxRequest('agent/cashBackState', {}, 'post')
        }
    },
    created(){
        wxRequest('agent/info', {}, 'post').then(res => {
            if(res.data.data.cashbackState == 0){
                this.$nextTick( () =>  this.secondBackState = false)               
            }else{
                this.$nextTick( () =>  this.secondBackState = true)  
            }
        })
    }
}
</script>
<style lang="less" scoped>
#secondBack {
    padding: 10px;
    section {
        margin-bottom: 20px;
        h3 {
            font-weight: bold;
            font-size: 15px;
            line-height: 30px;
        }
        ul {
            list-style: decimal inside;
            li {
                line-height: 1.8em;
            }
        }
    }
    .logo {
        margin-bottom: 20px;
        text-align: center;
        img {
            width: 70px;
            height: 70px;
            margin-bottom: 10px;
            border-radius: 50%;
            border: 2px solid #fff;
        }      
    }

}
</style>
